module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /Users/dago/Documents/Projects/briljant-2018/site/node_modules/axios/index.js
// module id = ../../node_modules/axios/index.js
// module chunks = 0